export default function React_Portals() {
  return (
    <div>
      <h1>React_Portals Component</h1>
      <p>This is the React_Portals tutorial page.</p>
    </div>
  );
}
